import { connect } from 'react-redux';
import AffiliateStatistic from '../component/AffiliateStatistic';
import actions from '../redux/actions/commission';
import orderTransAction from '../redux/actions/order_transaction_history';
import transAction from '../redux/actions/transactions';
import favoriteAction from '../redux/actions/favorite';

const mapStateToProps = (state) => ({
  setting: state.affiliate.setting || [],
  currencyMarkets: state.setting.currencyMarkets,
  mapCurrencyMarkets: state.setting.mapCurrencyMarkets,
  pubkey: state.user.session.pubkey,
  arrCoins: state.setting.arrCoins,
  commissions: state.commission.commissions,
  usersCommission: state.commission.usersCommission,
  userCommission: state.commission.userCommission,
  listMapLevel: state.commission.listMapLevel,
  listPartners: state.commission.listPartners,
  coins: state.setting.coins,
  userInfo: state.user.userInfo,
  trans: state.transaction.trans,
  orderTransactions: state.orderTrans.orderTransactions,
  totalCountPartner: state.commission.totalCountPartner,
  favorite: state.favorite.favorite,
  favoriteDetail: state.favorite.favoriteDetail,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCommissionAll: (params, callback) => {
    dispatch(actions.fetchCommissionAll(params, callback));
  },
  fetchCommissionByTime: (params, callback) => {
    dispatch(actions.fetchCommissionByTime(params, callback));
  },
  fetchCommissionUsers: (params, callback) => {
    dispatch(actions.fetchCommissionUsers(params, callback));
  },
  fetchCommissionUserByTime: (params, callback) => {
    dispatch(actions.fetchCommissionUserByTime(params, callback));
  },
  fetchCommissionUser: (params, callback) => {
    dispatch(actions.fetchCommissionUser(params, callback));
  },
  fetchTotalReferal: (callback) => {
    dispatch(actions.fetchTotalReferal(callback));
  },
  fetchListMapLevel: (params, callback) => {
    dispatch(actions.fetchListMapLevel(params, callback));
  },
  fetchListPartners: (params, callback) => {
    dispatch(actions.fetchListPartners(params, callback));
  },
  onFetchUserOrderTransHistoryAction: (params, callback) => {
    dispatch(orderTransAction.fetchUserOrderTransHistoryAction(params, callback));
  },
  onFetchUserTransHistoryAction: (params, callback) => {
    dispatch(transAction.fetchUserTransHistoryAction(params, callback));
  },
  onFetchFavorite: (params, callback) => {
    dispatch(favoriteAction.fetchFavorite(params, callback));
  },
  onFetchFavoriteDetail: (params, callback) => {
    dispatch(favoriteAction.fetchFavoriteDetail(params, callback));
  },
  onCreateFavorite: (params) => {
    dispatch(favoriteAction.createFavorite(params));
  },
  onRemoveFavorite: (params) => {
    dispatch(favoriteAction.removeFavorite(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateStatistic);
